import React from 'react';
import { termsData } from '@/constants/termsConditionData';

export const TermsCondition = () => {
  const getIcon = (icon) => {
    //   const icons = { Lock, FileText, UserCheck };
    //   const Icon = icons[icon];
    //   return Icon ? <Icon className="mb-[1rem] h-[3rem] w-[3rem] text-[#e24e1f]" /> : null;
    //
  };

  return (
    <div className="mt-[12rem] flex w-full justify-center px-[2rem] font-inter lg:mt-[15rem]">
      <div className="w-full max-w-[100rem]">
        {/* Header */}
        <div className="mb-[4rem] text-center">
          <h1 className="mb-[1rem] text-[3.6rem] font-[700] text-[white]">{termsData.title}</h1>
          <p className="mx-auto max-w-[80rem] text-[1.6rem] text-[#828FA0]">{termsData.subtitle}</p>
        </div>

        {/* Sections */}
        {termsData.sections.map((section) => (
          <div key={section.id} className="mb-[2rem] rounded-xl bg-[#011936] p-[3rem]">
            {getIcon(section.icon)}
            <h2 className="mb-[1rem] text-[1.8rem] font-[700] text-[white] md:text-[1.9rem] lg:text-[2rem]">
              {section.title}
            </h2>

            {section.content.length > 1 ? (
              <ul className="list-disc space-y-[0.5rem] pl-[3rem] text-[1.6rem] text-[#828FA0]">
                {section.content.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            ) : (
              <p className="text-[1.6rem] text-[#555]">{section.content[0]}</p>
            )}
          </div>
        ))}

        {/* Footer */}
      </div>
    </div>
  );
};
